import ElementConstants from '../../../shared/constants/elements';

const InputGroupBlocks = {
	CONTACT :{
		type: ElementConstants.INPUTS.CONTACT,
		label: 'Contact',
		icon: 'contact'
	},
	ADDRESS :{
		type: ElementConstants.INPUTS.ADDRESS,
		label: 'Address',
		icon: 'map-marker'
	},
	CHECKBOXES: {
		type: ElementConstants.INPUT_GROUPS.CHECKBOXES,
		label: 'Checkboxes',
		icon: 'check-square-o'
	},
	RADIO_BUTTONS: {
		type: ElementConstants.INPUT_GROUPS.RADIO_BUTTONS,
		label: 'Multiple Choice',
		icon: 'dot-circle-o'
	},
	SELECT_MENU: {
		type: ElementConstants.INPUT_GROUPS.SELECT_MENU,
		label: 'Dropdown Menu',
		icon: 'caret-down-o-square'
	},
	TABLE: {
		type: ElementConstants.INPUT_GROUPS.TABLE,
		label: 'Table',
		icon: 'grid'
	}
	// RATING: {
	// 	type: ElementConstants.INPUT_GROUPS.RATING,
	// 	label: 'Rating',
	// 	icon: 'rating'
	// }
}

export default InputGroupBlocks;



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/editor/constants/blocks/input-groups.js